import { Outlet } from "@tanstack/react-router";
import { CityTable } from "@/app/Cities/Cities/Components/CityTable";

export function AdminCitiesScreen() {
  return (
    <div className="space-y-6">
      <h1 className="text-base font-semibold leading-6 text-gray-900">
        Cities
      </h1>
      <CityTable id="settings-cities" />
      <Outlet />
    </div>
  );
}
